export default {
  EXTERIOR: '360 Exterior',
  INTERIOR: '360 Interior',
  IMAGES: 'Gallery',
}
